import router from './router'
import commercialMessages from './localization'

export default {
  router,
  localization: commercialMessages,
}
